import DeparturesPage from './departures-page';

export default DeparturesPage;